import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { CONTACT } from "@/lib/site";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-ink text-white/70">
    <div className="mx-auto grid max-w-7xl gap-14 px-6 py-20 sm:grid-cols-2 lg:grid-cols-4 lg:px-10">
      <div>
        <div className="flex items-baseline gap-2">
          <span className="inline-block h-2.5 w-2.5 rounded-[3px] bg-pine" />
          <span className="font-serif text-xl font-semibold tracking-tight text-white">
            CalCor
          </span>
          <span className="text-sm font-medium text-white/50">Solutions</span>
        </div>
        <p className="mt-5 max-w-xs text-sm leading-relaxed">
          Accounting, audit preparation, and bookkeeping for small businesses and tribal
          governments. Seattle-based, serving clients remotely from anywhere.
        </p>
      </div>

      <nav aria-label="Footer pages">
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-white/40">Pages</p>
        <ul className="mt-5 space-y-3 text-sm">
          <li><Link data-testid="footer-home-link" to="/" className="transition-colors hover:text-white">Home</Link></li>
          <li><Link data-testid="footer-services-link" to="/services" className="transition-colors hover:text-white">Services</Link></li>
          <li><Link data-testid="footer-about-link" to="/about" className="transition-colors hover:text-white">About</Link></li>
          <li><Link data-testid="footer-insights-link" to="/insights" className="transition-colors hover:text-white">Insights</Link></li>
          <li><Link data-testid="footer-contact-link" to="/contact" className="transition-colors hover:text-white">Contact</Link></li>
        </ul>
      </nav>

      <nav aria-label="Footer services">
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-white/40">Services</p>
        <ul className="mt-5 space-y-3 text-sm">
          <li><Link data-testid="footer-accounting-link" to="/services#accounting" className="transition-colors hover:text-white">Accounting</Link></li>
          <li><Link data-testid="footer-audit-prep-link" to="/services#audit-preparation" className="transition-colors hover:text-white">Audit Preparation</Link></li>
          <li><Link data-testid="footer-bookkeeping-link" to="/services#bookkeeping" className="transition-colors hover:text-white">Bookkeeping</Link></li>
        </ul>
      </nav>

      <div>
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-white/40">Contact</p>
        <ul className="mt-5 space-y-3 text-sm">
          <li data-testid="footer-phone">{CONTACT.phone}</li>
          <li data-testid="footer-email">{CONTACT.email}</li>
          <li data-testid="footer-location">{CONTACT.location}</li>
        </ul>
        <Link
          to="/portal"
          data-testid="footer-client-portal-link"
          className="group mt-6 inline-flex items-center gap-1.5 rounded-full border border-white/20 px-5 py-2.5 text-sm font-semibold text-white transition-colors duration-300 hover:border-clay hover:text-clay"
        >
          Client Portal
          <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
        </Link>
      </div>
    </div>

    <div className="border-t border-white/10">
      <div className="mx-auto flex max-w-7xl flex-col gap-2 px-6 py-6 text-xs text-white/40 sm:flex-row sm:items-center sm:justify-between lg:px-10">
        <p data-testid="footer-copyright">© {new Date().getFullYear()} CalCor Solutions. All rights reserved.</p>
        <p>Seattle, WA · Serving clients everywhere</p>
        <Link to="/privacy" data-testid="footer-privacy-link" className="transition-colors hover:text-white/70">
          Privacy Policy
        </Link>
        <Link to="/admin" data-testid="footer-admin-link" className="transition-colors hover:text-white/70">
          Admin
        </Link>
      </div>
    </div>
  </footer>
);
